export enum OrganizationStatus {
  PENDING_REVIEW = "pending_review",
  ACTIVE = "active",
  REJECTED = "rejected",
  SUSPENDED = "suspended",
}
